import styles from "./styles.module.scss";
import { Slider } from "antd";

interface LaunchDateProps {
  launchDate: number | null;
  setLaunchDate: (value: number | null) => void;
}

export const LaunchDate = ({ launchDate, setLaunchDate }: LaunchDateProps) => {
  const handleDateChange = (value: number | null) => {
    setLaunchDate(value || 0);
  };

  return (
    <div className={styles.wrapper}>
      <span className={styles.title}>Launch Date</span>
      <div className={styles.sliderContainer}>
        <Slider
          min={0}
          max={100}
          value={launchDate}
          onChange={handleDateChange}
          className={styles.customSlider}
          railStyle={{
            backgroundColor: "#2e2e2e",
            height: "14px",
            borderRadius: "32px",
          }}
          trackStyle={{
            backgroundColor: "#5295e0",
            height: "14px",
            borderRadius: "32px",
          }}
          handleStyle={{
            backgroundColor: "#ffffff",
            marginTop: "0px",
            borderRadius: "32px",
            border: "2px solid #5295E0",
          }}
        />
      </div>
    </div>
  );
};
